import { Component } from '@angular/core';

@Component({
    selector: 'app-instrucciones',
    templateUrl: './instrucciones.component.html',
})
export class InstruccionesComponent {
    title = 'INSTRUCCIONES DE INSCRIPCIÓN EN EL SISTEMA INFORMÁTICO PARA COMERCIO EXTERIOR DE VEGETALES (CEXVEG)';
    subtitle = 'MÓDULOS DE IMPORTACIÓN:';
    p1 =
        'Para inscribirse en la aplicación CEXVEG en el módulo de  Importación y/o Expedición de certificados de exportación, será necesario cumplimentar los datos indicados en la pestaña correspondiente al Alta del Solicitante. Los datos a indicar son los siguientes:';
    p1l1 = 'Datos del representante:';
    p1l1l1 = 'Nombre, Apellidos, NIF/NIE.';
    p1l1l2 = 'Clase y Tipo de Solicitante.';
    p1l2 = 'Datos de contacto:';
    p1l2l1 = 'Número de teléfono, Correo electrónico y Fax.';
    p1l3 = 'Datos de la organización: ';
    p1l3l1 = 'Razón Social.';
    p1l3l2 = 'País, Provincia, Localidad, Tipo de vía pública, Nombre de la vía, Número, Código Postal.';
    p1l3l3 = 'NIF.';

    p2 = 'Los datos reflejados en la solicitud Web deberán coincidir con los de la'; //sigue un link en el html

    p3 = 'Una vez realizado el registro en la aplicación, se deberá presentar la';
    p3cont = 'en el sistema informático para comercio exterior de vegetales (CEXVEG), de una de las siguientes formas:';
    p3l1 = 'Envío de la documentación necesaria a través de la';
    p3l1cont = ', o bien,';
    p3l2 = 'Envío de la documentación física a través de una de las siguientes direcciones:';
    p3l2l1 =
        'El Registro General del MAPA (Paseo Infanta Isabel, 1, 28071 Madrid) dirigido a la Dirección General de Sanidad de la Producción Agraria (Subdirección General de Acuerdos Sanitarios y Control en Frontera; C/ Almagro, 33, 28010 - Madrid), o bien, ';
    p3l2l2 =
        'Los registros a que se refiere el artículo 16 de la Ley 39/2015, de 1 de octubre, del Procedimiento Administrativo Común de las Administraciones Públicas, dirigido a la misma dirección anterior.';

    p4 = 'La solicitud deberá venir acompañada de la siguiente documentación:';
    p4l1 = 'Persona jurídica: poder notarial que acredite la representación en nombre del solicitante al que representa.';
    p4l2 =
        'Título o autorización, emitida por la Agencia Tributaria que le acredite como Agente de Aduanas, Operador Económico Autorizado, Representante Aduanero o Transitario.';

    p5 =
        'El sistema al validar la petición de usuario le inscribirá automáticamente en el Sistema de “Acceso Unificado de Aplicaciones€ del MAPA denominado REGEUS” (Registro General de Usuarios del MAPA).';
}
